import React from "react";
import CompletedStocks from "./CompletedStocks";
import { BsChevronDoubleUp, BsChevronDoubleDown } from "react-icons/bs";

export default function CompletedLists({ buyingList, deleteStock }) {
  return (
    <div className="buy card text-white bg-primary m-1 mb-3">
      <a
        href="#0"
        className="btn btn-link p-0 m-0 text-light position-absolute"
        id="main-collapse1"
        data-toggle="collapse"
        data-target="#collapseExample1"
        aria-expanded="true"
        aria-controls="collapseExample1"
      >
        <i className="hany2">
          <BsChevronDoubleUp />
        </i>
        <i className="hany">
          <BsChevronDoubleDown />
        </i>
      </a>
      <div className="d-flex card-header pr-2">
        <h5 className="mb-0">الصفقات المكتملة</h5>
      </div>
      <div
        className="card-body bg-light text-dark p-0 collapse show"
        id="collapseExample1"
      >
        <>
          {buyingList.some((list) => list.completed) ? (
            <div className="table-responsive-xl">
              <table className="table table-hover table-striped m-0">
                <thead className="text-center">
                  <tr className="text-center table-light text-dark">
                    <th scope="col">الشركة</th>
                    <th scope="col">تاريخ الشراء</th>
                    <th scope="col">
                      الفترة <small>(يوم)</small>
                    </th>
                    <th scope="col">الكمية</th>
                    <th scope="col">م الشراء</th>
                    <th scope="col">م البيع</th>
                    <th scope="col">اجمالي العمولات</th>
                    <th
                      scope="col"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="تكلفة الشراء بالاضافة لعمولات الشراء والبيع"
                    >
                      اجمالي التكلفة
                    </th>
                    <th scope="col">الربح/الخسارة</th>
                    <th scope="col">الصافي</th>
                    <th scope="col">التحكم</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  <>
                    {buyingList
                      .sort((a, b) => (b.date > a.date ? 1 : -1))
                      .map((list) => {
                        return (
                          <CompletedStocks
                            key={list.id}
                            list={list}
                            deleteStock={deleteStock}
                          />
                        );
                      })}
                  </>
                </tbody>
              </table>
            </div>
          ) : (
            <div className="d-flex flex-column justify-content-center align-items-center card-body bg-light text-dark">
              <h5 className="mb-0">لا توجد صفقات مكتملة</h5>
            </div>
          )}
        </>
      </div>
    </div>
  );
}
